import React, {CSSProperties} from "react"
import {Button, Modal, Stack} from "@mui/material";
import Box from "@mui/material/Box";
import {styled} from "@mui/styles";
import {VerticalInterval} from "~/components/LayoutComponents";
import {Icons} from "~/components/IconContainer"
import {CustomButton} from "~/components/ButtonComponents"; // ButtonComponents는 CustomButton을 export하고 있습니다.
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

type ModalType = "normal" | "confirm" | "sevenday" | "sevendayBiz" | 'save';
export type ModalParam = {
  open: boolean;
  content?: string;
  type?: ModalType;
  hideBackdrop?: boolean;
  title?: string;
  isDist?: boolean;
  noButton?: boolean;
  buttonName?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  outlinedblack?: boolean;
  borderRadius?: string;
  style?: CSSProperties;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

export const ModalComponents: React.FC<{
  children?:any
  open: boolean,
  content?: string,
  type?: ModalType,
  hideBackdrop?: boolean,
  title?: string,
  onConfirm?: (type:string) => void,
  onClose?: (type:string) => void,
  style?: CSSProperties,
  confirmButtonText?: string,
  cancelButtonText?: string,
}> = props => {
  const type = props.type || "normal";
  const confirmLabel = props.confirmButtonText || (type == "normal" ? "확인" : "예");
  const cancelLabel = props.cancelButtonText || "아니오";
  // const navigate = useNavigate();

  // Add isBiz check here
  const isBiz = typeof window !== 'undefined' && window.location.pathname.startsWith('/biz');

  const handlerConfirm = (event: React.MouseEvent<HTMLElement>) => {
    if (props.onConfirm) props.onConfirm("handlerConfirm")
  }

  const handlerExit = (event: React.MouseEvent<HTMLElement>) => {
    if(props.title == '602' || props.title == '603' || props.title == '407'){
      if (props.onConfirm) props.onConfirm(props.title)
    } else {
      if (props.onClose) props.onClose("handlerExit")
    }
  }

  const handlerExitClose = (event: React.MouseEvent<HTMLElement>) => {
    if (props.onClose) props.onClose("handlerExit")
  }

  const handlerModalClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (props.onClose) props.onClose("handlerModalClose")
  }

  const handlerOnChange = (event: React.MouseEvent<HTMLElement>) => {
    if (props.onClose) props.onClose("handlerOnChange")
  }

  const handlerOnChangeNew = (event: React.MouseEvent<HTMLElement>) => {
    if (props.onConfirm) props.onConfirm("handlerOnChangeNew")
  }


  return <>
    <Modal
      open={props.open}
      onClose={handlerModalClose}
      hideBackdrop={props.hideBackdrop}
      sx={{margin: '0 15px', zIndex: 10000000}}
    >
      {/* isBiz에 따라 biz-modal 클래스 추가 */}
      <ModalBoxContainer className={isBiz ? 'biz-modal' : ''}>
        <Stack justifyContent={"space-between"} flexDirection={"column"}>
          <Box style={{position:'absolute', right: 0, top: 20}}>
            <Button style={{width: "24px", height: "24px"}} onClick={handlerExit}>
              {<Icons.Exit/>}
            </Button>
          </Box>

          <Box sx={{pb: "32px"}}>
            {
              props.children ? <>
                {
                  props.title ? <h2>{props.title}</h2> : <VerticalInterval size={"40px"}/>
                }
                {props.children}
              </> : <>
                {
                  props.title ?
                    <h2 style={{textAlign: "center", marginBottom: "20px" }}>{props.title}</h2> :
                    <VerticalInterval size={"40px"}/>
                }
                <p style={{textAlign: "center", whiteSpace: 'pre-line'}}>{props.content}</p>
              </>
            }
          </Box>
          <div className="alert-area">
          <div className="btn-area" style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
            {type === 'confirm' && (
              <button className={`btn md line-primary`} style={{ width: 'fit-content' }} onClick={handlerExitClose}>
                {cancelLabel}
              </button>
            )}

            {type === "normal" && (
              <button className={`btn md fill-primary`} style={{ width: 'fit-content' }} onClick={handlerConfirm}>
                {confirmLabel}
              </button>
            )}
            {
              type === "confirm" && (
                <button className={`btn md fill-primary`} style={{ width: 'fit-content' }} onClick={props.confirmButtonText ? handlerConfirm : handlerExit}>
                  {confirmLabel}
                </button>
              )
            }
            {
              type === "sevenday" && (
                <CustomButton type={"popup"} label={"정상계정 전환하기"} onClick={handlerOnChange} color={isBiz ? 'outlinedbizblack' : 'outlined'}/>
              )
            }
            {
              (type === "sevenday") && (
                <CustomButton type={"popup"} label={"새로 가입하기(14세 미만 이동)"} onClick={handlerOnChangeNew} color={isBiz ? 'bizPrimary' : 'primary'}/>
              )
            }
            {
              type === "sevendayBiz" && (
                <CustomButton type={"popup"} label={"정상계정 전환하기"} onClick={handlerOnChange} color={isBiz ? 'outlinedbizblack' : 'outlined'}/>
              )
            }
            {
              (type === "sevendayBiz") && (
                <CustomButton type={"popup"} label={"가입정보입력(사업자)"} onClick={handlerOnChangeNew} color={isBiz ? 'bizPrimary' : 'primary'}/>
              )
            }
            </div>
          </div>
        </Stack>
      </ModalBoxContainer>
    </Modal>
  </>
}

const ModalBoxContainer = styled(Box)({
  position: 'absolute',
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: '480px',
  width: '100%',
  backgroundColor: "white",
  borderRadius: '20px',
  margin: "0",
  padding: "24px",
  '@media (min-width: 320px) and (max-width: 768px)' : {
    maxWidth: '320px',
  }
})